module.exports = __webpack_public_path__ + "static/media/hulu-lawsuit.5bccc671.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hulu-lawsuit.jpg
// module id = 943
// module chunks = 0